import { MedicalSpecialty, Person } from 'schema-dts';

import { PhysicianData } from '@/features/profile/profile.types';

import useFullName from './useFullName';

/**
 * Generates Person schema for provider data
 *
 * See {@link https://schema.org/Person} for schema documentation
 * @param {OasProvider} data
 * @returns
 */
function usePersonSchema(data: PhysicianData): Person {
  const fullName = useFullName({
    firstName: data?.physicianFirstName,
    middleInitial: data?.physicianMiddleInitial ?? undefined,
    lastName: data?.physicianLastName,
    designation: data?.physicianDesignation,
  });

  const person: Person = {
    '@type': 'Person',
    knowsLanguage: data?.Languages ?? ['English'],
    name: fullName,
    image: data?.physicianPhotoUrl ?? '',
    knowsAbout: data?.providerSpecialties
      ? (data?.providerSpecialties.map(
          (specialty) => specialty.specialty
        ) as Array<MedicalSpecialty>)
      : [],
    gender: data?.gender ?? '',
    affiliation: data?.affiliations
      ? data?.affiliations.map((affiliation) => {
          return {
            '@type': 'Hospital',
            name: affiliation.locationName,
          };
        })
      : [],
    alumniOf: data?.credentialsAndAccreditations
      ? data?.credentialsAndAccreditations
          .filter((edu) => edu.type === 'Graduate Degree')
          .map((edu) => edu.organizationOrSchool)
      : [],
  };

  return person;
}

export default usePersonSchema;
